import React from 'react';

export default function Circle(props) {
  return (
    <span className={`app-circle ${props.className}`}>{props.children}</span>
  );
}
